<template>
  <div class="password-stepper create-account-stepper">
    <v-container class="main-container">
      <v-row>
        <v-col cols="12">
          <v-card
            class="deposit-form password-field create-account-form"
            :color="$vuetify.theme.dark ? 'transparent' : 'transparent'"
          >
            <v-row dense>
              <v-col cols="12" sm="8" md="7">
                <fieldset>
                  <legend>Select Crypto Network</legend>
                  <v-select
                    v-model="formData.network"
                    solo
                    :items="networks"
                    item-text="network"
                    item-value="renamedNetwork"
                    append-icon="mdi-chevron-down"
                    label="Select One"
                    class="custom-select"
                    :error-messages="networkError"
                    @input="validateNetwork"
                  ></v-select>
                </fieldset>
              </v-col>
              <v-col cols="12" sm="8" md="7">
                <fieldset class="mt-3">
                  <legend>Enter Your Crypto Address</legend>
                  <v-text-field
                    v-model="formData.address"
                    label="Enter your crypto address"
                    single-line
                    solo
                    :error-messages="addressError"
                    @input="validateAddress"
                    class="custom-select"
                  ></v-text-field>
                </fieldset>
              </v-col>
              <v-col cols="12" sm="8" md="7">
                <v-card-actions class="pa-0 mt-3">
                  <v-btn
                    class="ma-0 text-capitalize btn-account"
                    color="greenMain"
                    tile
                    width="146px"
                    elevation="0"
                    :loading="loading"
                    :disabled="!isValid || loading"
                    @click="handleSubmit"
                  >
                    Save
                  </v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { CRYPTO__ACTIONS } from "@/store/action-types";

export default {
  data() {
    return {
      loading: false,
      formData: {
        network: "",
        address: "",
      },
      networkError: "",
      addressError: "",
    };
  },

  computed: {
    ...mapState("crypto", ["networks"]),
    isValid() {
      return (
        this.formData.network &&
        this.formData.address &&
        !this.networkError &&
        !this.addressError
      );
    },
  },

  methods: {
    ...mapActions("crypto", [CRYPTO__ACTIONS.CREATE, CRYPTO__ACTIONS.NETWORKS]),

    validateNetwork(value) {
      this.networkError = !value ? "Network is required" : "";
    },

    validateAddress(value) {
      if (!value) {
        this.addressError = "Address is required";
      }  else {
        this.addressError = "";
      }
    },

    async handleSubmit() {
      if (!this.isValid) return;

      this.loading = true;
      try {
        const submitData = {
          ...this.formData,
          crypto_type: this.formData.network, // Add crypto_type if needed
          status: 1, // Default active status
        };
        await this[CRYPTO__ACTIONS.CREATE](submitData);
        this.resetForm();
      } catch (error) {
        console.error("Error saving address:", error);
      } finally {
        this.loading = false;
      }
    },

    resetForm() {
      this.formData = {
        network: "",
        address: "",
      };
      this.networkError = "";
      this.addressError = "";
    }
  },

  async mounted() {
    await this[CRYPTO__ACTIONS.NETWORKS]();
  },
};
</script>